export default __webpack_public_path__ + "static/media/jupiter.c2cadd83.jpg";